import { FC } from 'react';
import map from 'lodash/map';
import startCase from 'lodash/startCase';
import Item from 'antd/lib/form/FormItem';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import Input from 'antd/lib/input/Input';
import Select from 'antd/lib/select';

const { Option } = Select;

import { paymentsAccountNonUSAFields, paymentsAccountUSAFields } from 'components/Settings/fieldsConstants';

const PaymentsAccountInformation: FC = () =>
  <>
    <h4 className="mt-4 mb-5">Account Information</h4>
    <Item shouldUpdate>
      {({ getFieldValue }) => getFieldValue('countryId') === 238
        ? <Row gutter={20}>
          {map(paymentsAccountUSAFields, ({ name, label, component: Component, options, rules }) =>
            <Col span={12} key={name}>
              <Item name={name} label={label} rules={rules} validateFirst>
                <Component size="large" placeholder={`Enter ${label}`} className="w-full">
                  {options && map(options, (option) =>
                    <Option key={option} value={option}>{startCase(option)}</Option>)}
                </Component>
              </Item>
            </Col>)}
        </Row>
        : <Row gutter={20}>
          {map(paymentsAccountNonUSAFields, (field) =>
            <Col span={12} key={field.name}>
              <Item {...field}>
                <Input size="large" placeholder={`Enter ${field.label}`} />
              </Item>
            </Col>)}
        </Row>}
    </Item>
  </>;

export default PaymentsAccountInformation;
